import { ProcessStep } from "./process-step.model";
import { LastActionStatus } from "./last-action-status.enum";
import { JobOfferPayload } from "./candidate-action.model";
import { Tag } from "./common/tag.model";

export enum jobOfferStatusTypes {
  PENDING = "pending",
  REJECTED = "rejected",
  MATCH = "match",
}

interface JobOffer {
  status: jobOfferStatusTypes;
  metadata: JobOfferPayload;
}

export interface WageClaims {
  brl?: string;
  usd?: string;
  eur?: string;
}

export interface Quartile {
  min?: number;
  max?: number;
}

export interface CandidateProcess {
  total: number;
}

export interface Candidate {
  id: string;
  user_id: string;
  initials_name: string;
  experience_time?: string;
  experience_time_tech?: string;
  experience_time_ecosystem?: string;
  wage_claim: string;
  remote: boolean;
  phone?: string;
  time_availability?: {
    start: string;
    end: string;
  }[];
  city?: {
    name?: string;
    state?: string;
  };
  last_action?: {
    created?: string;
    status: LastActionStatus;
    recruiter: {
      id: string;
      name: string;
    };
    id: string;
  };
  company_hired: string;
  main_skills?: main_skills[];
  skills: string[];
  hire_types: hire_types[];
  selection?: {
    action_id: number;
    source_id: string;
    source: string;
    expire: Date;
    origin_name?: string;
    origin_type?: string;
  };
  english_level?: string;
  full_name?: string;
  email?: string;
  is_pool?: boolean;
  work_model_presencial: boolean;
  work_model_hybrid: boolean;
  job_offer?: JobOffer;
  processStep?: ProcessStep;
  wage_claim_was_converted?: boolean;
  wage_claims?: WageClaims[];
  wage_claim_currency?: string;
  tags?: Tag[];
  has_completed?: boolean;
  quartile?: Quartile;
}

export interface main_skills {
  name: string;
}

export interface hire_types {
  name: string;
}

export interface CandidateSimple {
  id: string;
  initials_name: string;
  wage_claims: WageClaims;
  wage_claim: number;
  score: number;
  fit: number;
  wage_claim_currency: string;
  experience_time_tech: string;
  remote: boolean;
  work_model_presencial: boolean;
  work_model_hybrid: boolean;
  hire_types: hire_types[];
}
